import React, { useState } from "react";
import addblogimg from "../../Images/add blog.jpg";

import "./AddBlog.css";

const AddBlog = () => {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [detailText, setDetailText] = useState("");
  const [author, setAuthor] = useState("");
  const [error, setError]= useState(false);

  // API on click call function
  const addBlog = async() => {
    console.log(!title);

    // form validation
    if(!title || !image || !detailText || !author){
      setError(true)
      return false;
    }

    // for get user id from localStorage
    const userId= JSON.parse(localStorage.getItem('user'))._id ;

    let result= await fetch("http://localhost:5000/add-blog",{
      method:'POST',
      body: JSON.stringify({title,image,detailText,author,userId}),
      headers:{
        "content-type":"application/json"
      }
    });

    result= await result.json();
    console.warn(result)
  alert('blog uploded')
  };

  return (
    <div className="add-blog-component">
      <div className="add-blog-img-container">
        <img src={addblogimg} alt="xxx" />
      </div>
      <h1 className="add-blog-main-heading">Add Blog</h1>
      <div className="add-blog-inp-box-container form-about-support-page-avcom-inner">
        <input
          type="text"
          placeholder="Enter title here"
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
          }}
          className="input-add-blog-box"
        />
        <input
          type="file"
          placeholder="Enter image here"
          value={image}
          onChange={(e) => {
            setImage(e.target.value);
          }}
          className="input-add-blog-box"
        />
        <textarea
          type="text"
          rows="10" cols="50"
          placeholder="Write Blog here ..."
          value={detailText}
          onChange={(e) => {
            setDetailText(e.target.value);
          }}
          className="input-add-blog-box input-text-area-blog-box"
        />
        <input
          type="text"
          placeholder="Enter Author name here"
          value={author}
          onChange={(e) => {
            setAuthor(e.target.value);
          }}
          className="input-add-blog-box"
        />{" "}
        <br />
        <button className="add-blog-btn" onClick={addBlog}>
          Add blog
        </button>
      </div>
    </div>
  );
};

export default AddBlog;
